import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const items = [
  {
    quote: "Paragon shipped our MVP in 6 weeks — ahead of schedule. The AI features they built doubled our signups.",
    name: "Rohit Sharma",
    role: "Founder, FinLoop",
    img: "https://images.unsplash.com/photo-1758600587811-e9a20851cf7d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxzbWlsaW5nJTIwcHJvZmVzc2lvbmFsJTIwcG9ydHJhaXQlMjBicmlnaHQlMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3Njg2NTA0MHww&ixlib=rb-4.1.0&q=85",
    bg: "bg-[#FBD46D]",
  },
  {
    quote: "Their mobile team rebuilt our React Native app from scratch. Crashes dropped 90% and the App Store rating jumped to 4.8.",
    name: "Aisha Kapoor",
    role: "VP Product, HealthTrek",
    img: "https://images.unsplash.com/photo-1758600587815-b654d1405e83?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxzbWlsaW5nJTIwcHJvZmVzc2lvbmFsJTIwcG9ydHJhaXQlMjBicmlnaHQlMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3Njg2NTA0MHww&ixlib=rb-4.1.0&q=85",
    bg: "bg-[#E0F2FE]",
  },
  {
    quote: "Finally, a dev partner that gets AI and design. We moved from prototype to paying customers in under two quarters.",
    name: "Daniel Okafor",
    role: "CEO, Quanta AI",
    img: "https://images.unsplash.com/photo-1758600436605-7e43ac56f707?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxzbWlsaW5nJTIwcHJvZmVzc2lvbmFsJTIwcG9ydHJhaXQlMjBicmlnaHQlMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3Njg2NTA0MHww&ixlib=rb-4.1.0&q=85",
    bg: "bg-[#FCE7F3]",
  },
];

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 md:py-32 bg-white border-b-4 border-gray-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <span className="inline-block bg-[#6BCB77] border-[3px] border-gray-900 rounded-full px-4 py-1 text-xs font-bold uppercase tracking-[0.2em] nb-shadow-sm">
            Clients love us
          </span>
          <h2 className="font-display mt-5 text-4xl sm:text-5xl md:text-6xl leading-tight">
            Words from founders<br /> who trusted us.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {items.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`testimonial-card-${i}`}
              className={`${t.bg} border-[4px] border-gray-900 rounded-2xl p-7 nb-shadow nb-hover flex flex-col`}
            >
              <Quote size={36} className="text-gray-900 mb-4" />
              <p className="text-lg font-medium leading-relaxed text-gray-900 flex-1">
                "{t.quote}"
              </p>
              <div className="mt-6 flex items-center gap-4 pt-5 border-t-2 border-gray-900/10">
                <img
                  src={t.img}
                  alt={t.name}
                  className="w-14 h-14 rounded-full object-cover border-[3px] border-gray-900"
                />
                <div>
                  <div className="font-display text-lg leading-tight">{t.name}</div>
                  <div className="text-sm font-bold text-gray-700">{t.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
